import { channels } from "@/mocks/portal";

const scopeRows = [
  { icon: "ri-search-eye-line", title: "按关键词找内容", desc: "输入人物、平台或事件关键词，直接命中对应专题与内容查询结果。" },
  { icon: "ri-stack-line", title: "按领域筛分区", desc: "娱乐、财经、网红、饭圈等分区内翻页浏览，按频道逐层下钻。" },
  { icon: "ri-timer-flash-line", title: "按热度追更新", desc: "追踪检索热榜与时效专题，第一时间锁定被高频查找的内容。" },
];

export default function QueryZone() {
  return (
    <section id="query" className="scroll-mt-24 bg-foreground-950 py-12 text-background-50 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-700 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-search-line text-sm"></i>内容查询分区
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight md:text-3xl">
              按领域进行内容查询
            </h2>
            <p className="mt-2 text-sm text-background-300">
              六大领域分区索引，配合关键词快速筛选，找到你要查的目标专题。
            </p>
          </div>
          <a
            href="#topics"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/30 bg-background-50/10 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
          >
            回顾专题精选 <i className="ri-arrow-up-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((c) => (
            <a
              key={c.no}
              href="#feed"
              className="group relative overflow-hidden rounded-xl border border-background-200/10 bg-background-100 p-5 transition-colors hover:border-accent-400/60 md:p-6"
            >
              <span className="font-heading text-4xl font-black text-background-200/50 transition-colors group-hover:text-accent-400/70">
                {c.no}
              </span>
              <div className="mt-3 flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-background-50 group-hover:text-accent-200">
                  {c.name}
                </h3>
                <i className="ri-arrow-right-up-line text-background-300 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-accent-300"></i>
              </div>
              <p className="mt-2 text-[13px] leading-6 text-background-300/90">{c.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.chips.map((chip) => (
                  <span
                    key={chip}
                    className="rounded-full bg-background-200/20 px-2.5 py-1 text-[11px] text-background-200 whitespace-nowrap"
                  >
                    #{chip}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center gap-1.5 border-t border-background-200/10 pt-3 text-xs text-background-300/70">
                <i className="ri-eye-line text-primary-400"></i>
                {c.reads}
              </div>
            </a>
          ))}
        </div>

        {/* 三种查询方式 */}
        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {scopeRows.map((r, i) => (
            <div key={r.title} className="flex items-start gap-3 rounded-lg bg-background-100 p-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${r.icon} text-lg`}></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-background-50">
                  <span className="mr-1.5 text-xs text-accent-300">{String(i + 1).padStart(2, "0")}</span>
                  {r.title}
                </p>
                <p className="mt-1 text-xs leading-5 text-background-300/90">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}